import { ProcessingJobType } from "@prisma/client";
import { TKey } from "@/app/translations/TKey";
import { HomeActivationStep } from "@/app/types/home/HomePricing";
import { Credits, ProcessingPrice, sequenceGenerationCost } from "@/app/vars/Credits";

export const HOME_ACTIVATION_VARIANTS = 5;

export const HOME_PRICING_PERKS: TKey[] = [
  TKey.HOME_MEIDLY_PRICING_PERK_1,
  TKey.HOME_MEIDLY_PRICING_PERK_2,
  TKey.HOME_MEIDLY_PRICING_PERK_3,
];

export const HOME_ACTIVATION_STEPS: HomeActivationStep[] = [
  {
    labelKey: TKey.HOME_MEIDLY_PRICING_STEP_CALLS,
    credits: Credits.ANALYSIS_CREDITS_PER_HOUR,
  },
  {
    labelKey: TKey.HOME_MEIDLY_PRICING_STEP_AVATAR,
    credits: ProcessingPrice[ProcessingJobType.CLIENT_AVATAR],
  },
  {
    labelKey: TKey.HOME_MEIDLY_PRICING_STEP_CRITERIA,
    credits: ProcessingPrice[ProcessingJobType.PROSPECT_SEARCH],
  },
  {
    labelKey: TKey.HOME_MEIDLY_PRICING_STEP_SEQUENCE,
    credits: sequenceGenerationCost(
      ProcessingPrice[ProcessingJobType.MESSAGE_SEQUENCE],
      HOME_ACTIVATION_VARIANTS,
    ),
  },
];
